export default __webpack_public_path__ + "static/media/user.ed2a2883.svg";